import {
  base_colorRaisedSurface,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.ReportingAgentFlyout {
    .BaseFlyout-Container {
      color: ${text_colorTextPrimary};
    }

    .BaseFlyout-Content {
      overflow: hidden;
      background-color: ${base_colorRaisedSurface};

      .BaseFlyout-CloseBar {
        padding-right: ${spacing(8)};
        padding-left: ${spacing(8)};
        background-color: ${base_colorRaisedSurface};
      }

      .BaseFlyout-Body {
        min-height: 0;
        display: flex;
        flex-direction: column;
        padding-top: ${spacing(4)};
        padding-right: ${spacing(8)};
        padding-bottom: ${spacing(4)};
        padding-left: ${spacing(8)};
        background-color: ${base_colorRaisedSurface};
      }
    }
  }
`
